import React from 'react';
import {observer} from 'mobx-react';
import _ from 'lodash';
import OptionalCoverages from './OptionalCoverages';
import {Panel} from 'components';
import EligibilityRecords from './EligibilityRecords';

const BenefitInfoAdminForm = observer(({uiState}) => {
  return (
    <Panel.Stack loose>
      <OptionalCoverages uiState={uiState}/>
      <EligibilityRecords uiState={uiState}/>
    </Panel.Stack>
  );
});

export default BenefitInfoAdminForm;
